module.exports = __webpack_public_path__ + "img/individual.f182b467.jpg";